var React = require('react');

function Powerfulicon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","fill":"#000","key":0},[React.createElement("path",{"d":"M16.855 8.122l-5.1-5.667a.567.567 0 00-.422-.188h-3.4a.567.567 0 00-.422.945l4.76 5.288-4.759 5.287a.566.566 0 00.422.946h3.4c.16 0 .312-.07.421-.187l5.1-5.666a.567.567 0 000-.758z","key":0}),React.createElement("path",{"d":"M9.488 8.122l-5.1-5.667a.567.567 0 00-.42-.188h-3.4a.567.567 0 00-.422.945L4.904 8.5.146 13.787a.566.566 0 00.421.946h3.4c.161 0 .313-.07.422-.187l5.1-5.666a.567.567 0 000-.758z","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("path",{"fill":"#fff","d":"M0 0h17v17H0z"})))]);
}

Powerfulicon.defaultProps = {"width":"17","height":"17","fill":"none"};

module.exports = Powerfulicon;

Powerfulicon.default = Powerfulicon;
